const {
  wrapWithIterableIterator,
  ensureIterable
} = require('../../internal/iterable.js');

function* __concat(...sources) {
  for (const iterable of sources) {
    yield* ensureIterable(iterable);
  }
}

exports.__concat = __concat;
const concat = /*#__PURE__*/wrapWithIterableIterator(__concat);
exports.concat = concat;